import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import BasicOrderBy from "./BasicOrderBy";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { FEED_PREFERENCES } from "../utils/constants";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import { Button, FormControlLabel, FormGroup, Switch } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import MultiSelect from "./MultiSelect";

class SearchOptionMenu extends React.Component {
  state = {
    anchorEl: null,
    loading: false
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      pitsMetadataStore,
      basicSearchStore,
      videoSearchStore,
      onSave
    } = this.props;
    const { anchorEl } = this.state;

    return (
      <div>
        <IconButton
          aria-label="More"
          aria-owns={anchorEl ? "long-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          style={{ padding: "6px" }}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              padding: "8px",
              overflow: "visible"
            }
          }}
        >
          <FormGroup
            style={{ padding: "12px", marginBottom: "0.5rem", width: "400px" }}
          >
            <BasicOrderBy precedence="primary" />

            <FormControl style={{ margin: "8px" }}>
              <InputLabel htmlFor="feed-preference">Feed Preference</InputLabel>
              <Select
                value={videoSearchStore.feedPreference}
                onChange={e =>
                  (videoSearchStore.feedPreference = e.target.value)
                }
                inputProps={{
                  name: "Feed Preference",
                  id: "feed-preference"
                }}
              >
                {FEED_PREFERENCES.map((fp, i) => (
                  <MenuItem key={i} value={fp.value}>
                    {fp.label}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                Optional setting to default feed type for plays
              </FormHelperText>
            </FormControl>

            <FormControl style={{ margin: "8px" }}>
              <MultiSelect
                id={`returning-fields`}
                label={"Returning Fields"}
                values={basicSearchStore.returning.slice()}
                onChange={values => (basicSearchStore.returning = values)}
                options={Object.values(pitsMetadataStore.fields).map(field => ({
                  label: field.displayName,
                  value: field.name
                }))}
              />
              <FormHelperText>
                Additional data to return with search
              </FormHelperText>
            </FormControl>
          </FormGroup>

          <Divider />

          <div
            style={{
              padding: "8px",
              paddingTop: "16px",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <FormControlLabel
              checked={basicSearchStore.playsOnly}
              onChange={e => (basicSearchStore.playsOnly = e.target.checked)}
              control={<Switch />}
              label="Plays Only"
              style={{ marginLeft: "2px", marginBottom: "8px" }}
            />

            <Button
              size={"small"}
              color={"primary"}
              disabled={this.state.loading}
              onClick={e => {
                onSave && onSave();
                this.handleClose();
              }}
            >
              {this.state.loading ? (
                <CircularProgress size={"small"} />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Menu>
      </div>
    );
  }
}

export default inject(
  "basicSearchStore",
  "matchupsDialogStore",
  "videoSearchStore",
  "pitsMetadataStore",
  "routerStore"
)(observer(SearchOptionMenu));



// WEBPACK FOOTER //
// ./src/components/SearchOptionMenu.js